import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
// hocs
import { withConnectModalActions } from '../../hocs';
// ui
import { Flex, ModalActionButton, ModalCancelButton } from '../../ui';
//////////////////////////////////////////////////

const defaultBtnStyles = { width: 120 };

const defaultBoxStyles = {
  width: '100%',
  justifyContent: 'space-between',
};

export const FormFooter = withConnectModalActions((props) => (
  <Flex {...G.mergeAndSpreadUiStyles(defaultBoxStyles, props.boxStyles)}>
    <ModalCancelButton
      {...G.mergeAndSpreadUiStyles(defaultBtnStyles, props.cancelBtnStyles)}
      type='button'
      onClick={R.or(props.cancelAction, props.closeModal)}
    >
      {R.pathOr(G.getWindowLocale('actions:cancel', 'Cancel'), ['cancelBtnText'], props)}
    </ModalCancelButton>
    {
      G.isNotNilAndNotEmpty(props.actionButtons) &&
      props.actionButtons.map(({ type, action, disabled, displayText, buttonStyles }, i) => (
        <ModalActionButton
          {...G.mergeAndSpreadUiStyles(defaultBtnStyles, buttonStyles)}
          key={i}
          onClick={action}
          disabled={disabled}
          type={R.or(type, 'button')}
          cursor={G.ifElse(disabled, 'not-allowed')}
          form={G.ifElse(R.equals(type, 'submit'), props.formId)}
        >
          {displayText}
        </ModalActionButton>
      ))
    }
    <ModalActionButton
      {...G.mergeAndSpreadUiStyles(defaultBtnStyles, props.submitBtnStyles)}
      form={props.formId}
      data-testid={props.submitButtonTestId}
      type={R.or(props.submitButtonType, 'submit')}
      disabled={R.or(G.isTrue(props.isSubmitting), props.submitDisabled)}
      cursor={G.ifElse(R.or(G.isTrue(props.isSubmitting), props.submitDisabled), 'not-allowed')}
      onClick={() => {
        if (G.isFunction(R.path(['submitAction'], props))) props.submitAction();
      }}
    >
      {R.pathOr(G.getWindowLocale('actions:submit', 'Submit'), ['submitBtnText'], props)}
    </ModalActionButton>
  </Flex>
));

export const ChargeFormFooter = (props) => (
  <FormFooter
    {...props}
    boxStyles={{ p: '15px', bg: G.getTheme('colors.dark.mainLight') }}
  />
);
